/* eslint-disable no-nested-ternary */
import React from 'react'
import Pro2 from 'image/detail/pro2.png'
import moment from 'moment'
import logo from 'image/logo_icon.png'
import { request } from 'meinian-package/src/utils'
import { Table, EditIdeaMass, LookLgjDetail, Share, Sharing, InspirationTransfer, Pagination } from 'component'
import { Icon, Modal, DeleteColl } from 'meinian-package/src/component'
import { QuickAccess } from 'baseComponent'
import { Dropdown, Ul, Li, Loading, Empty } from 'meinian-package/src/baseComponent'
import { DownloadAll, ExportAll } from 'component/batch/options'
import { IDEA_MASS_ROLE } from 'meinian-package/src/component/enum'
import { teamHasAuth } from 'meinian-package/src/utils/auth'
import { ossImg } from 'meinian-package/src/utils/image'
import styles from './index.module.less'

const columns = ({ initTable, onExitCooperation }) => {
  return [
    {
      title: '灵感集',
      dataIndex: 'ins',
      key: 'ins',
      width: 320,
      render: (_h, record) => {
        return <div className={styles['mn-ins-column']} onClick={() => window.open(`/meinian/home/coll/detail/${record.id}?inspirationId=${record.id}&tab=${record.isDataAnalysis ? 4 : ''}`, '_self')}>
          <div className="ins-cover">
            { (record.coverImgUrl || record.lastBlogList[0]?.mainUrl) ? <img className="main-img" src={ossImg(record.coverImgUrl || record.lastBlogList[0].mainUrl, 400, 400)} /> : <img className="empty-img" src={logo} />}
            <div className="hover-mask" />
          </div>
          <div className="ins-right">
            <div className="ins-title">
              {record.isPro === 1 && <img src={Pro2} className="ins-img" />}{record.name}
            </div>
            <div className="ins-info">
              <div className="ins-info-name">{record.ownerName}</div>
              <div className="ins-info-line" />
              <div>
                <span
                  className="cooper"
                  onClick={async (e) => {
                    e && e.stopPropagation()
                    const res = await request.get('/zhikuan/ins/inspiration/get-inspiration-info', { params: { inspirationId: record.id } })
                    Modal.info({
                      style: { whiteSpace: 'pre-wrap' },
                      title: '协作成员',
                      hiddenFooter: true,
                      children: <div className="mn-cooperation-modal-content">{res.userList?.map(user => <div className="coop-user">{/* TODO */}
                        <div className="user-avatar"><img src={user.avatar} /></div>
                        <span className="user-name">{user.userName}</span>
                      </div>)}</div>
                    })
                  }}
                >{record.userNum}人协作</span>
              </div>
            </div>
          </div>
        </div>
      }
    },
    { title: '款式总数', dataIndex: 'blogNum', width: 92, sorter: true, key: 'blogNum' },
    { title: '未提交审核', dataIndex: 'unMarkNum', width: 110, sorter: true, key: 'unMarkNum' },
    { title: '待审核', dataIndex: 'prepareMarkNum', width: 92, sorter: true, key: 'prepareMarkNum' },
    { title: '审核通过', dataIndex: 'markPassNum', width: 92, sorter: true, key: 'markPassNum' },
    { title: '批注款式', dataIndex: 'annotationNum', width: 92, sorter: true, key: 'annotationNum' },
    { title: '更新时间', dataIndex: 'updatedAt', width: 120, key: 'updatedAt', render: (h, record) => { return <span className={styles['mn-ins-date-column']}>{moment(record.updatedAt).format('YYYY-MM-DD')}</span> } },
    { title: '创建时间', dataIndex: 'createdAt', width: 120, key: 'createdAt', render: (h, record) => { return <span className={styles['mn-ins-date-column']}>{moment(record.createdAt).format('YYYY-MM-DD')}</span> } },
    {
      title: '操作',
      dataIndex: 'options',
      width: 230,
      key: 'options',
      fixed: 'right',
      render: (h, record) => {
        const onSticky = async (e, topStatus) => {
          e && e.stopPropagation()
          if (topStatus) {
            await request.get('/ins/inspiration/remove-top', { params: { inspirationId: record.id } })
          } else {
            await request.get('/ins/inspiration/set-top', { params: { inspirationId: record.id } })
          }
          initTable?.()
        }

        const auth = record.loginUserInfo?.inspirationPermissions || []

        const authExitCooperation = [IDEA_MASS_ROLE.AUDITOR, IDEA_MASS_ROLE.GATHER, IDEA_MASS_ROLE.VIEWER].includes(record.loginUserInfo.role)

        return <div className={styles['mn-ins-options-column']}>
          {auth.includes('F03') ? <EditIdeaMass
            auth={auth}
            inspirationId={record.id}
            onChange={() => initTable?.()}
            onDelete={() => initTable?.()}
          >编辑</EditIdeaMass> : null}
          {auth.includes('F06') ? <EditIdeaMass
            auth={auth}
            inspirationId={record.id}
            mode={2}
            onChange={() => initTable?.()}
          >协作成员</EditIdeaMass> : null}
          <span onClick={e => onSticky(e, record.topStatus)}>{ record.topStatus ? '取消置顶' : '置顶'}</span>
          <Dropdown
            trigger="hover"
            getPopupContainer={() => document.querySelector('.meinian') || document.body}
            placement="bottomRight"
            className="mn-image-card-operation"
            overlayStyle={{ padding: '8px' }}
            overlay={<Ul style={{ width: 148 }}>
              {auth.includes('F02') ? <>
                <LookLgjDetail
                  inspirationId={record.id}
                  onChange={() => initTable?.()}
                  onDelete={() => initTable?.()}
                >
                  <Li className="mn-dropdown-icon-li"><Icon type="m-xiangqing" />灵感集详情</Li>
                </LookLgjDetail>
                <div className="li-partition" />
              </>
                : null}
              <QuickAccess
                isQuickAccess={record?.isQuickAccess}
                id={record.id}
                name={record.name}
                onChange={() => initTable?.()}
              >
                <Li className="mn-dropdown-icon-li" onClick={(e) => { e.preventDefault() }}><Icon type={record?.isQuickAccess ? 'm-quxiaokuaisufangwen' : 'm-kuaisufangwen'} />{record?.isQuickAccess ? '移除快速访问' : '快速访问'}</Li>
              </QuickAccess>
              {(auth.includes('FC10') || auth.includes('F09')) && teamHasAuth('meinian_share_inspiration') ? <Li
                className="mn-dropdown-icon-li"
                onClick={() => {
                  (record?.shareStatus ? Sharing.show({
                    inspirationId: record?.id,
                    name: record?.name,
                    cooperation: record?.cooperation,
                    auth,
                    onChange: initTable })
                    : Share.show({ auth, inspirationId: record?.id, name: record?.name, cooperation: record?.cooperation, onChange: initTable }))
                }}
              ><Icon type={record?.shareStatus ? 'm-fenxiang' : 'm-fenxiang'} onClick={(e) => { e.preventDefault() }} />{record?.shareStatus ? '分享中' : '分享'}</Li> : null}
              {
                    (teamHasAuth('meinian_download_all_blog') || teamHasAuth('meinian_export_all_blog')) && <div className="li-partition" />
                  }
              {
                  teamHasAuth('meinian_download_all_blog') && <DownloadAll inspirationId={record?.id}>
                    <Li className="mn-dropdown-icon-li" onClick={(e) => { e.preventDefault() }}><Icon type="m-xiazai" />下载全部款式</Li>
                  </DownloadAll>
                }
              {
                  teamHasAuth('meinian_export_all_blog') && <ExportAll inspirationId={record?.id}>
                    <Li className="mn-dropdown-icon-li" onClick={(e) => { e.preventDefault() }}><Icon type="m-daochu" />导出全部款式</Li>
                  </ExportAll>
                }
              {
                  authExitCooperation && <>
                    <div className="li-partition" />
                    <Li className="mn-dropdown-icon-li" onClick={(e) => onExitCooperation(record.id, e)}><Icon type="m-tuichu" />退出协作</Li>
                  </>
                }
              {auth.includes('F15')
                ? <>
                  <div className="li-partition" />
                  <InspirationTransfer
                    className="inspiration-transfer"
                    inspirationId={record?.id}
                    onChange={() => initTable?.()}
                  >
                    <Li className="mn-dropdown-icon-li" onClick={(e) => { e.preventDefault() }}><Icon type="m-zhuanrang" />转让</Li>
                  </InspirationTransfer>
                </> : null}
              { auth.includes('F04')
                ? <>
                  <div className="li-partition" />
                  <Li
                    className="mn-dropdown-icon-li delete"
                    onClick={(e) => {
                      e.preventDefault()
                      DeleteColl({ params: { inspirationId: record?.id }, onDelete: () => initTable?.() })
                      e.stopPropagation()
                    }}
                  ><Icon type="m-shanchu" />删除</Li>
                </>
                : null}
            </Ul>}
          >
            <span>更多</span>
          </Dropdown>
        </div>
      }
    }
  ]
}

export default ({ data, totalCount, pageNo, sortParams, onSort, onPageChange, loading, initData, onExitCooperation }) => {
  return <div className={styles['mn-coll-content']}>
    <Loading spinning={loading}>
      {data?.length ? <Table
        onSort={({ key: sortKey, sort }) => {
          onSort({ sortKey, sort })
        }}
        className="mn-home-coll-ins-table"
        data={data}
        columns={columns({ initTable: () => initData(),
          onExitCooperation
        })}
        sortValue={{ key: sortParams.sortKey, sort: sortParams.sort }}
        scroll={{ x: 0, y: document.body.clientHeight - 340 }}
      /> : !loading ? <Empty title="暂无相关灵感集" /> : null}
      {totalCount > 20 ? <div className="coll-pagination">
        <Pagination
          pageNo={pageNo}
          pageSize={20}
          total={totalCount}
          onChange={(_pageNo) => {
            onPageChange({
              pageNo: _pageNo,
              start: (_pageNo - 1) * 20
            })
          }}
        />
      </div> : null}
    </Loading>
  </div>
}
